export const FETCH_DISTRIBUTORS_SUCCESS = 'fetch_distributors_success'
export const ADD_DISTRIBUTOR_SUCCESS = 'add_distributor_success'
export const FETCH_DISTRIBUTOR_DETAILS_SUCCESS = 'fetch_distributor_details_success'
export const UPDATE_DISTRIBUTOR_SUCCESS = 'update_distributor_success'
export const FETCH_DISTRIBUTOR_METRICS_SUCCESS = 'fetch_distributor_metrics_success'
export const FETCH_DISTRIBUTOR_TREND_SUCCESS = 'fetch_distributor_trend_success'
export const FETCH_CUSTOMER_TAGS_SUCCESSS = 'FETCH_CUSTOMER_TAGS_SUCCESSS'
export const FETCH_CUSTOMER_CCL_SUCCESS = 'FETCH_CUSTOMER_CCL_SUCCESS'
